import { ROLE_NAME } from '@dashboard/library';
import { UserFullFragment_roles } from '@generated/UserFullFragment';

export interface RoleFlags {
  isAgent: boolean;
  isAdmin: boolean;
  isOwner: boolean;
  isSupervisor: boolean;
}

export function getRoleFlags(roles: UserFullFragment_roles[]): RoleFlags {
  const roleNames = roles.map(({ name }) => name);
  const isAdmin = roleNames.includes(ROLE_NAME.ADMIN);
  const isAgent = roleNames.includes(ROLE_NAME.AGENT);
  const isOwner = roleNames.includes(ROLE_NAME.OWNER);
  const isSupervisor = roleNames.includes(ROLE_NAME.SUPERVISOR);

  return { isAdmin, isAgent, isOwner, isSupervisor };
}
